const isValidJSON = jsonString => {
	try {
		const json = JSON.parse(jsonString);
		return json;
	} catch (error) {
		return false;
	}
};

export { isValidJSON };
